module.exports = __webpack_public_path__ + "static/media/edit.fed3dd0d.svg";